import React, { useState } from 'react';
import TabContext from '@mui/lab/TabContext';

import { useSelector } from 'react-redux';
import { selectCommandByNodeId, State } from '@store/index';
import { TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { ToggleStream } from '@common/Node/NodeSidebar/Custom/ToggleStream';
import { NodeSidebar, NodeSidebarTab, NodeSidebarTabsContainer } from '@common/Node/NodeSidebar';
import { ArticleOutlined } from '@mui/icons-material';
import { SchemaEditor } from '@common/Node/NodeSidebar/Custom/SchemaEditor';
import { Toggle } from '@common/Node/NodeSidebar/Custom/Toggle';
import { NodeData } from '@common/Node/NodeSidebar/NodeData';

export const ResponseTabs: React.FC = () => {
  const [tab, setTab] = useState('1');

  const command = useSelector((state: State) => selectCommandByNodeId(state, state.tabs.active.selectedNode));
  if (!command) return;

  const state = command.state;
  const fields = command.fields;

  const responseToggle = fields.find((field) => field.id === 'response_method');
  const formatResponse = fields.find((field) => field.id === 'format_response');
  const formatSchema = fields.find((field) => field.id === 'format_schema');

  const formatResponseEnabled = state?.format_response === 'true';
  const formatSchemaValue = state?.format_schema?.value;

  return (
    <NodeSidebar>
      <TabContext value={tab}>
        <NodeSidebarTabsContainer color={command.config.background}>
          <TabList onChange={(_, newTab) => setTab(newTab)}>
            <Tab disableRipple label='Node' value='1' />
            <Tab title='Data' disableRipple iconPosition='start' icon={<ArticleOutlined />} value='2' />
          </TabList>
        </NodeSidebarTabsContainer>
        <TabPanel value='1'>
          <NodeSidebarTab>
            {responseToggle && <ToggleStream command={command} field={responseToggle} />}
            {formatResponse && state.response_method !== 'stream' && (
              <Toggle command={command} field={formatResponse} />
            )}
            {formatSchema && state.response_method !== 'stream' && (
              <SchemaEditor
                command={command}
                field={formatSchema}
                enabled={formatResponseEnabled}
                nodeValue={formatSchemaValue}
              />
            )}
          </NodeSidebarTab>
        </TabPanel>
        <TabPanel value='2'>
          <TabPanel value='2'>
            <NodeData command={command} terminal />
          </TabPanel>
        </TabPanel>
      </TabContext>
    </NodeSidebar>
  );
};
